 window.colors = {
   "pastel blue": "#87CEEB",
  "sage green": "#8B9467",
  "dark grey": "#333333",
  "white": "#FFFFFF",
  "green": "#008000",
  "yellow": "#FFFF00",
  "beige": "#F5F5DC",
  "brown": "#964B00",
  "blue": "#0000FF",
  "light yellow": "#FFFFE0",
  "pink": "#FFC0CB",
  "light blue": "#ADD8E6",
  "dark blue": "#03055B",
  "light green": "#C6F4D6",
  "brown-beige": "#dfac80",
  "red-blue": "#ce263a",
  "orange": "#FFA500",
  "natural hemp": "#ecded2",
  "dark wine": "#eb0521",
  "adventurous ash": "#e2f8f4",
  "spirited olive": "#dae9e5",
  "warrior green": "#3a6309",
  "defender blue": "#50e3c2",
  "swift steel": "#d8dad5",
  "valiant navy": "#0b4b96",
  "wonder wine": "#8a0817",
  "maroon": "#801b28",
  "black": "#000000",
  "olive green": "#7ed321",
  "gray": "#b8e986",
  "warm grey": "#9b9b9b",
  "athletic aqua": "#50e3c2",
  "gritty grey": "#7ed321",
  "gutsy green": "#7ed321",
  "passionate blue": "#4a90e2",
  "resolute grey": "#9b9b9b",
  "vintage olive": "#3f5d80",
  "sky blue": "#b7cee9",
  "purple": "#9013fe",
  "mustard": "#d1c41e",
  "lavender": "#4be7c4",
  "arctic blue": "#45A0E6",
  "hustling teal": "#0097A7",
  "light pink": "#FFB6C1",
  "coral": "#FFC67D",
  "cadet blue": "#5F9EA0",
  "grape": "#6f2da8",
  "navy blue": "#03055B",
  "turquoise": "#1ABC9C",
  "light green": "#d1eeb1",
  "brown-beige": "#dfac80",
  "natural hemp": "#ecded2",
  "dark wine": "#eb0521",
  "adventurous ash": "#e2f8f4",
  "spirited olive": "#dae9e5",
  "warrior green": "#3a6309",
  "defender blue": "#50e3c2",
  "swift steel": "#d8dad5",
  "valiant navy": "#0b4b96",
  "wonder wine": "#8a0817",
  "orange": "#f5a623",
  "maroon": "#801b28",
  "black": "#000000",
  "olive green": "#7ed321",
  "gray": "#b8e986",
  "warm grey": "#9b9b9b",
  "athletic aqua": "#50e3c2",
  "gritty grey": "#7ed321",
  "gutsy green": "#7ed321",
  "passionate blue": "#4a90e2",
  "resolute grey": "#9b9b9b",
  "vintage olive": "#3f5d80",
  "sky blue": "#b7cee9",
  "purple": "#9013fe",
  "natural hemp": "#eeddcf",
  "mustard": "#d1c41e",
  "lavender": "#4be7c4"
};
// console.log('custom.js loaded');